<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />

    <div id="contents" class="clearfix">
      <div id="main_area">
        <div class="information">
          <h3>B203 保險含括聲明查詢</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tr>
                <td>身分證統一編號</td>
                <td>
                  <input
                    type="text"
                    size="10"
                    maxlength="10"
                    v-model="form.idn"
                  />
                </td>
              </tr>
              <tr>
                <td>姓名</td>
                <td>
                  <input
                    type="text"
                    size="40"
                    maxlength="49"
                    v-model="form.name"
                  />
                </td>
              </tr>
              <tr>
                <td colspan="2" class="f_center">
                  <input
                    type="submit"
                    class="btn"
                    value="查詢"
                    @click="doQuery()"
                  />
                  <input
                    type="submit"
                    class="btn"
                    value="重填"
                    @click="doClear()"
                  />
                </td>
              </tr>
            </table>
          </div>
          <!-- <div align="center">
            <p>
              <input
                type="submit"
                class="btn"
                value="查詢"
                @click="doQuery()"
              />
              <input
                type="submit"
                class="btn"
                value="重填"
                @click="doClear()"
              />
            </p>
            <p>&nbsp;</p>
          </div> -->
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table width="100%">
            <tr>
              <td></td>
              <td v-if="grid && grid.paginaiton" align="right">
              <input
                type="button"
                value="<<"
                class="btn"
                style="height: 28px"
                @click="form.currentpage = grid.paginaiton.pageNo - 1"
                v-show="grid.paginaiton.pageNo > 1"
              />
              <span
                v-for="(data, index) in grid.paginaiton.pages"
                :key="index"
                style="cursor: pointer"
                :style="
                  grid.paginaiton.pageNo == data ? 'color:red' : 'color:black'
                "
                @click="form.currentpage = parseInt(data)"
              >
                {{ grid.paginaiton.pageNo == data ? "[" + data + "]" : data }}
              </span>
              <input
                type="button"
                class="btn"
                value=">>"
                style="height: 28px"
                v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                @click="form.currentpage = grid.paginaiton.pageNo + 1"
              />
              ［每頁<input
                type="text"
                v-model.number.lazy="form.pagesize"
                size="2"
              />

              <input type="button" class="btn" value="筆" />，第<input
                type="text"
                v-model.number.lazy="form.currentpage"
                size="2"
              />
              <input type="button" class="btn" value="頁" />，共
              {{ grid.paginaiton.totalPage }} 頁
              {{ grid.paginaiton.totalCount }} 筆］
            </td>
            </tr>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th>操作</th>
                    <th>姓名</th>
                    <th>身分證字號</th>
                    <th>保險含括年度</th>
                    <th>聲明上傳日</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="列印"
                        data-toggle="modal"
                        data-target=".bs-example-modal-lg"
                        @click="doPrint(data)"
                      />
                    </td>
                    <td>{{data.name}}</td>
                    <td>{{data.idn}}</td>
                    <td>{{data.year}}</td>
                    <td>{{data.datetime}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- 查詢結果結束-->
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>

    <CyFooter />

    <Alert v-model="Alert.show" :title="Alert.title" :ServiceUnit="pageData.ServiceUnit">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import CyFooter from "@/components/Common/CyFooter.vue";
import { getMenuIndex } from "@/config/util.js";
import
{
  B203_SearchGrid,
  B203_print
} from "@/service/api.js";

export default {
  name: "B203",
  data: function () {
    return {
      pageData: {
        MenuIndex: 1,
        PrgName: "B203",
        ServiceUnit: "CY",
        isForceLoginOut : true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      form: {
        idn:"",
        name:"",
        pagesize: 10,
        currentpage: 1,
      },
      grid: {gridDatas:[],paginaiton:[]},
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    CyFooter,
    Alert: VueModal,
  },
  methods: {
    doQuery: function () {
      const self = this;
      let postData = {
        idn: self.form.idn,
        name: self.form.name,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo:{
            Id:self.loginInfo.id,
            PrgCode:self.pageData.PrgName,
            ActCd:"查詢",
            ServiceUnit:self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          }
      };
      B203_SearchGrid(postData).then((rData) => {
        self.grid = rData.returnObject;
      });
    },
    doClear: function () {
      const self = this;
      self.form.idn = "";
      self.form.name = "";
    },
    doPrint: function (data) {
      const self = this;
      let postData = {
        SEQNO_I : data.seqnO_I,
        LogInfo:{
            Id:self.loginInfo.id,
            PrgCode:self.pageData.PrgName,
            ActCd:"列印保險含括聲明序號:" + data.seqnO_I,
            ServiceUnit:self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          }
      };
      B203_print(postData).then((rData) => {
        let link = document.createElement("a");
        link.download = self.form.name + "保險含括";
        link.href = "data:application/pdf;base64," + rData;
        link.click();
      });
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    self.pageData.MenuIndex = getMenuIndex(self.pageData.PrgName);
    if (self.pageData.MenuIndex === null) {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.doQuery();
  },
  watch:{
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.doQuery();
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.doQuery();
      }
    },
  },
};
</script>

<style scoped src="@/assets/css/Cy.css" />
